require("core-js/modules/esnext.global-this.js");

!function (e, s) {
  "object" == typeof exports && "undefined" != typeof module ? s(exports) : "function" == typeof define && define.amd ? define("tailwindcss-classnames", ["exports"], s) : s((e = "undefined" != typeof globalThis ? globalThis : e || self).TailwindcssClassnames = {});
}(this, function (e) {
  "use strict";

  var s = function (e, s) {
    return e(s = {
      exports: {}
    }, s.exports), s.exports;
  }(function (e) {
    /*!
    	  Copyright (c) 2017 Jed Watson.
    	  Licensed under the MIT License (MIT), see
    	  http://jedwatson.github.io/classnames
    	*/
    !function () {
      var s = {}.hasOwnProperty;

      function n() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var o = arguments[t];

          if (o) {
            var r = typeof o;
            if ("string" === r || "number" === r) e.push(o);else if (Array.isArray(o) && o.length) {
              var i = n.apply(null, o);
              i && e.push(i);
            } else if ("object" === r) for (var a in o) {
              s.call(o, a) && o[a] && e.push(a);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    }();
  }),
      n = s;

  e.classnames = s, e.default = n, e.tw = n, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});